import { render, staticRenderFns } from "./DialogDetailsPhysicalProgress.vue?vue&type=template&id=630a4c51&scoped=true"
import script from "./DialogDetailsPhysicalProgress.vue?vue&type=script&lang=js"
export * from "./DialogDetailsPhysicalProgress.vue?vue&type=script&lang=js"
import style0 from "./DialogDetailsPhysicalProgress.vue?vue&type=style&index=0&id=630a4c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a4c51",
  null
  
)

export default component.exports